export const isEmptyOrSpaces = (str : string) => {
    return (str.length === 0 || !str.trim());
}

 // Función para eliminar acentos básicos en una cadena
export function removeAccentsBasic(str:string) {
	return str
    	.normalize('NFD') // Descomponemos los caracteres en base y acento
    	.replace(/[\u0300-\u036f]/g, ''); // Eliminamos los caracteres de acento
}